<template>
    <transition name="fade">
        <div id="popup" v-if="isVisible" @click.self="maskClose">
            <div class="popup" @click.stop="isVisible = true">
                <div class="popup1">
                    <div>{{ title }}设定要求(非必填)</div>
                    <i class="el-icon-close cursor_1" @click="close"></i>
                </div>
                <el-input type="textarea" placeholder="请输入你的要求(无要求可直接点立即生成）" v-model="requireText" :maxlength="5000"></el-input>
                <div class="popup2">
                    <div class="popup3 cursor_1" @click="getRequire">立即生成</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props:{
        maskClick:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            isVisible: false,
            title: '',
            requireText: ''
        };
    },
    methods: {
        maskClose(){
            if(this.maskClick){
                this.close()
            }
        },
        open(title='',requireText='') {
            this.title = title;
            this.requireText = requireText
            this.isVisible = true;
        },
        close() {
            this.requireText = ''
            this.isVisible = false;
        },
        getRequire() {
            this.$emit('getRequire', this.requireText);
            this.requireText = '';
            this.isVisible = false;
        }
    }
};
</script>

<style scoped>
#popup {
    width: 100%;
    height: 100vh;
    background-color: #0000006b;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
}

.popup {
    width: 583px;
    height: 375px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 25px 30px;
}

.popup1 {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    font-size: 17px;
    color: #111111;
    margin-bottom: 17px;
}

.el-icon-close {
    font-weight: bold;
}

::v-deep .el-textarea__inner {
    width: 100%;
    background-color: transparent;
    border: none;
    resize: none;
    outline: none;
    box-shadow: none;
    background-color: #FAFAFA;
    height: 230px;
}

.popup2 {
    display: flex;
    justify-content: end;
    margin-top: 17px;
}

.popup3 {
    width: 125px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
}

/* 动画样式 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>    